// extracted by mini-css-extract-plugin
export default {"root":"Icons_root__MbZhn","grid":"Icons_grid__Cvn96","item":"Icons_item__aBf+V","buttonWrapper":"Icons_buttonWrapper__U3OIs","itemImage":"Icons_itemImage__lwlwT"};